export const GET_drawer = ({ drawer }) => drawer
export const GET_role = ({ role }) => role
export const GET_is_admin = ({ is_admin }) => is_admin
export const GET_is_teacher = ({ is_teacher }) => is_teacher
export const GET_is_editorLeader = ({ is_editorLeader }) => is_editorLeader
export const GET_is_editor = ({ is_editor }) => is_editor
